import {FormModel} from "./form.model.abstract";
import {ValidatorFn} from "@angular/forms";

/**
 * Input of a number. Uses plu/minus button for de/increasing the value
 */
export class FormModelNumber extends FormModel {

  /**
   * @inheritDoc
   */
  public type = 'number';

  /**
   * @inheritDoc
   * @param id
   * @param validators
   * @param unit
   * @param value
   * @param info
   */
  constructor(id: string, validators: ValidatorFn[] = [], unit: string = null, value: any = null, info: boolean = true) {
    super(id, validators, unit, value, info);
  }
}
